import { Injectable } from "@angular/core";
import { TradeDealPromiseService } from "shared/cubiq-services";
import { BfxRBACService } from "../../bfx-common/services/bfx-rbac.service";
import { BfxUserProfileService } from "../../bfx-common/services/bfx-user-profile.service";

import {
  BfxBlotterTradeContextMenuItem,
  BfxBlotterTradeDialogActionEvent,
  BfxTradeContextMenuService,
} from "../../bfx-blotter-trade/services/bfx-trade-contextmenu.service";

export class BfxBlotterRiskTradeContextMenuItem extends BfxBlotterTradeContextMenuItem {
  //
}

export class BfxBlotterRiskTradeDialogActionEvent extends BfxBlotterTradeDialogActionEvent {
  //
}

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxRiskTradeContextMenuService extends BfxTradeContextMenuService {
  constructor(
    tradeDealService: TradeDealPromiseService,
    rbacService: BfxRBACService,
    userProfileService: BfxUserProfileService,
    // FIXME: is-a has-a
    _bfxTradeContextMenuService: BfxTradeContextMenuService,
  ) {
    super(tradeDealService, rbacService, userProfileService);

    this.actionSubject = _bfxTradeContextMenuService.actionSubject;
  }

  protected initMenuItems(): void {
    // Trades should not be confirmed in risk trades blotter
    this.permissions.canConfirmTrade = false;

    super.initMenuItems();
  }
}
